export default __webpack_public_path__ + "4ab7cceee7964f52691458ee2eadbdb6.png";